export default "__VITE_ASSET__e38c18f0__"